<script>
  import { trackLinkClick } from '../../../../../js/trackLinkClick';

  // TODO (leeryan) (EDI-757): There is currently a bug that is preventing links from appending hrefs to the URL for XMS pages.
  // This function is a workaround until the bug is fixed.
  function appendHrefToUrl() {
    window.location.href = '#main-content';
  }
</script>

<a
  id="main-content-jump-link"
  class="MainContentJumpLink"
  href="#main-content"
  on:click={appendHrefToUrl}
  use:trackLinkClick={{
    id: 'main-content-jump-link',
    title: 'Skip to Content',
    url: '#main-content',
  }}
>
  Skip to Content
</a>

<style>.MainContentJumpLink {
  position: absolute;
  display: block;
  z-index: 4;
  top: 78px;
  left: -9999px;
  background-color: #fff;
  color: #1a1a1a;
  padding: 10px 10px;
  border: 2px solid #006aff;
  border-radius: 5px;
  font-weight: var(--font-weight-medium, 500);
  text-decoration: none;
}

.MainContentJumpLink:focus {
  left: 15px;
}</style>
